import * as React from 'react';

import { useCreationDefaults } from 'common/hooks';
import { translate as t } from 'common/utils/translate';

import { Title } from 'common/components';
import { Section } from 'templates/core';
import ProgramCore from '../components/ProgramCore';

const ProgramCreate = () => {
  const defaultValues = useCreationDefaults();

  return (
    <>
      <Section>
        <Title size="big">{t('Create lifestyle program')}</Title>
      </Section>
      <ProgramCore defaultValues={defaultValues} layout="creation" />
    </>
  );
};

export default ProgramCreate;
